"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = Link;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Link.css"));
var _clsx = require("clsx");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-target-blank */

/***** STYLES *****/

/***** COMPONENT *****/
function Link(props) {
  const {
    children,
    onClick,
    url,
    target = 'self',
    title = '',
    rel,
    theme = 'black',
    size = '16'
  } = props;
  return /*#__PURE__*/React.createElement("a", {
    target: `_${target}`,
    title: title,
    onClick: event => {
      if (onClick) {
        onClick(event);
      }
    },
    href: url,
    className: (0, _clsx.clsx)(styles['element'], theme === 'primary' && styles['primary'], size === '14' && styles['size-s'], size === '28' && styles['size-l']),
    rel: rel
  }, children);
}